import { ActionPoint, RiskZoneId, SurveyGroup } from '@/types'

export const zonesOrder: RiskZoneId[] = ['profit_zone', 'growth_zone', 'potential_zone', 'risk_zone', 'loss_zone']
export const dimensions: ActionPoint['dimension'][] = ['trusty', 'sincerity', 'care', 'competence', 'reliability']

export type DimensionColor = {
  tailwind: string
  code: string
  codeLight: string
}

export const dimensionColors: Record<ActionPoint['dimension'] | 'leadership', DimensionColor> = {
  trusty: { tailwind: 'bg-nriched-violet text-white', code: '#3b3a6d', codeLight: '#484779' },
  sincerity: { tailwind: 'bg-nriched-blue', code: '#7780be', codeLight: '#878ec3' },
  care: { tailwind: 'bg-nriched-orange', code: '#ff9c37', codeLight: '#ffa950' },
  competence: { tailwind: 'bg-nriched-yellow', code: '#ffc22a', codeLight: '#ffc943' },
  reliability: { tailwind: 'bg-nriched-nude', code: '#ffe4c9', codeLight: '#feebd7' },
  leadership: { tailwind: 'bg-nriched-leadership', code: '#7368e0', codeLight: '#667fff' },
}

export const surveyGroupColors: Record<SurveyGroup, string> = {
  Meta: 'bg-fuchsia-200',
  Mitarbeiter: 'bg-indigo-100',
  Lieferanten: 'bg-violet-100',
  Kunden: 'bg-green-100',
}
